import * as formValidation from 'Modules/formValidation';


namespace BHW.caseLookup {
	const GET_CASEID = '/api/salesforce/get-case-id';

	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');

	let $email = $('#email');
	let $caseNumber = $('#case-number');

	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');

	let $loadIndicator = $('.js-load-indicator');

	let constraints = {
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Email Required'
					},
			email: {
				message: '^' + 'Email Invalid'
			}
		},
		'case-number': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Case Number Required'
			}
		}
	};

	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: constraints,
			values: {
				email: $email.val(),
				'case-number': $caseNumber.val(),
			}
		})) {

		}
	};

	let inputEventListeners = function () {
		$email.on('blur change', validateField);
		$caseNumber.on('blur change', validateField);
	};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');


			if (formValidation.validateWrapperSubmit({
					constraints: constraints,
					values: {
						email: $email.val(),
						'case-number': $caseNumber.val(),
					}
			})) {
				//form goes through
			} else {
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}



			let data = {
				email: $email.val(),
				caseNumber: $caseNumber.val(),
			};

			$.get(GET_CASEID, data)
				.done(function (data) {					
					if(data['errorMessage'] == null || data['errorMessage'] == "")
					{
					  $alertSuccess.removeClass('hidden');
					  $loadIndicator.addClass('state-loading');
					  location.assign(location.href + '?key=' + data['key']);
					}
					else
					{
						$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						.text(data['errorMessage']);
					}
				})
				.fail(function (jqXHR) {
					console.log(jqXHR.statusText);
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text');
						
				})
				.always(function () {
					window.scrollTo(0, 0);
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
				})
		});
	};

	export const init = () => {
		inputEventListeners();
		submitEventListener();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	BHW.caseLookup.init();
});
